<template>
  <div class="mainDiv">
    <h3 style="margin-bottom: 20px" v-if="courseName">{{ courseName }}</h3>
    <div style="position: relative">
      <el-tabs v-model="activeName" @tab-click="tabChange">
        <el-tab-pane label="查看回答" name="1">
          <QuestionAnswer />
        </el-tab-pane>
      </el-tabs>
      <div style="position: absolute; right: 8px; top: -6px">
        <el-button type="info" @click="back"> 返回提问列表 </el-button>
      </div>
    </div>
  </div>
</template>

<script>
 
import QuestionAnswer from './questionAnswer.vue'
export default {
  components: {
    QuestionAnswer
  },
  data() {
    return {
      courseName: this.$route.query.activeName,
      activeName: this.$route.query.tab,
      batchId: this.$route.query.batchId,
      courseId: this.$route.query.courseId,
      aswerType: this.$route.query.aswerType,
      type: '',
    }
  },
  watch: {
    $route: {
      handler: function (val) {
        this.type = val.query.tab
      },
      immediate: true,
    },
  },
  created(){
    console.log('我是测试',this.batchId)
  },
  methods: {
    tabChange(tab) {
      if (tab.name === this.type) return
      let query = {
        tab: tab.name,
        batchId: this.batchId,
        courseId: this.courseId,
        courseName: this.courseName,
      }
      this.$router.push({
        query,
      })
    },
    back() {
      if(this.aswerType == '1'){
        this.$router.back()
      }else{
        this.$router.push(`/TutionLearningManagement?tab=3&batchId=${this.batchId}&courseId=${this.courseId}&activeName=${this.courseName}`)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>